import { render, staticRenderFns } from "./CompareScores.vue?vue&type=template&id=20b3d7cc"
import script from "./CompareScores.vue?vue&type=script&lang=js"
export * from "./CompareScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports